/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ next: NonNullable<unknown>, total: NonNullable<unknown> }} Booking_Session_OfInputs */

const en_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Session ${i?.next} of ${i?.total}`)
};

const es_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sesión ${i?.next} de ${i?.total}`)
};

const de_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Golfstunde ${i?.next} von ${i?.total}`)
};

const zh_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`第 ${i?.next} 节课，共 ${i?.total} 节`)
};

const ar_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`الجلسة ${i?.next} من ${i?.total}`)
};

const fr_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Séance ${i?.next} de ${i?.total}`)
};

const vi_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Buổi ${i?.next} trên ${i?.total}`)
};

const sw_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kipindi ${i?.next} kati ya ${i?.total}`)
};

const th_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`เซสชันที่ ${i?.next} จาก ${i?.total}`)
};

const bs_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sesija ${i?.next} od ${i?.total}`)
};

const ja_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total}回中${i?.next}回目`)
};

const ko_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total}회 중 ${i?.next}회차`)
};

const pt_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sessão ${i?.next} de ${i?.total}`)
};

const it_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sessione ${i?.next} di ${i?.total}`)
};

const sv_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Session ${i?.next} av ${i?.total}`)
};

const nl_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sessie ${i?.next} van ${i?.total}`)
};

const da_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Session ${i?.next} af ${i?.total}`)
};

const nb_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Økt ${i?.next} av ${i?.total}`)
};

const fi_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kerta ${i?.next}/${i?.total}`)
};

const pl_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sesja ${i?.next} z ${i?.total}`)
};

const ru_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Занятие ${i?.next} из ${i?.total}`)
};

const tr_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seans ${i?.next}/${i?.total}`)
};

const hi_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} में से सत्र ${i?.next}`)
};

const id_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sesi ${i?.next} dari ${i?.total}`)
};

const ms_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sesi ${i?.next} daripada ${i?.total}`)
};

const cs_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lekce ${i?.next} z ${i?.total}`)
};

const el_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Συνεδρία ${i?.next} από ${i?.total}`)
};

const he_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`מפגש ${i?.next} מתוך ${i?.total}`)
};

const af_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sessie ${i?.next} van ${i?.total}`)
};

const hu_booking_session_of = /** @type {(inputs: Booking_Session_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.next}. alkalom / ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Session {next} of {total}" |
*
* @param {Booking_Session_OfInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_session_of = /** @type {((inputs: Booking_Session_OfInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Session_OfInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_session_of(inputs)
	if (locale === "de") return de_booking_session_of(inputs)
	if (locale === "zh") return zh_booking_session_of(inputs)
	if (locale === "ar") return ar_booking_session_of(inputs)
	if (locale === "fr") return fr_booking_session_of(inputs)
	if (locale === "vi") return vi_booking_session_of(inputs)
	if (locale === "sw") return sw_booking_session_of(inputs)
	if (locale === "th") return th_booking_session_of(inputs)
	if (locale === "bs") return bs_booking_session_of(inputs)
	if (locale === "ja") return ja_booking_session_of(inputs)
	if (locale === "ko") return ko_booking_session_of(inputs)
	if (locale === "pt") return pt_booking_session_of(inputs)
	if (locale === "it") return it_booking_session_of(inputs)
	if (locale === "sv") return sv_booking_session_of(inputs)
	if (locale === "nl") return nl_booking_session_of(inputs)
	if (locale === "da") return da_booking_session_of(inputs)
	if (locale === "nb") return nb_booking_session_of(inputs)
	if (locale === "fi") return fi_booking_session_of(inputs)
	if (locale === "pl") return pl_booking_session_of(inputs)
	if (locale === "ru") return ru_booking_session_of(inputs)
	if (locale === "tr") return tr_booking_session_of(inputs)
	if (locale === "hi") return hi_booking_session_of(inputs)
	if (locale === "id") return id_booking_session_of(inputs)
	if (locale === "ms") return ms_booking_session_of(inputs)
	if (locale === "cs") return cs_booking_session_of(inputs)
	if (locale === "el") return el_booking_session_of(inputs)
	if (locale === "he") return he_booking_session_of(inputs)
	if (locale === "af") return af_booking_session_of(inputs)
	if (locale === "hu") return hu_booking_session_of(inputs)
	return en_booking_session_of(inputs)
});